export function Footer() {
  return (
    <footer data-testid="app-footer" className="border-t border-border bg-card/40 mt-12">
      <div className="px-4 md:px-8 lg:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-sm text-muted-foreground">
        <div>© {new Date().getFullYear()} Kipkruiden.nl B.V.</div>
        <div className="font-mono uppercase tracking-widest text-xs">
          Voorraad- en inkoopinformatie vanuit kipkruiden.nl
        </div>
      </div>
    </footer>
  );
}
